import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uniqueId from 'lodash/uniqueId'

class Circle extends Component {
  static defaultProps = {
    noStreak: false,
    pathProps: {},
    svgProps: {},
    proTrackProgress: 0,
  }

  static propTypes = {
    circleProps: PropTypes.shape({
      r: PropTypes.number.isRequired,
      cx: PropTypes.number.isRequired,
      cy: PropTypes.number.isRequired,
      strokeWidth: PropTypes.number.isRequired,
    }).isRequired,
    svgProps: PropTypes.object,
    proTrackProgress: PropTypes.number,
    streakCurrent: PropTypes.number,
  }

  state = {
    id1: uniqueId('circle-gradient-1'),
    id2: uniqueId('circle-gradient-2'),
  }

  render() {
    const { circleProps, svgProps, proTrackProgress, streakCurrent } = this.props
    const { r, cx, cy, strokeWidth } = circleProps
    if (!r || !cx || !cy || !strokeWidth) {
      throw new Error(`Cannot draw circle without radius, center or stroke-width`)
    }
    const circleLength = 2 * Math.PI * r
    const strokeDashoffset = circleLength - proTrackProgress * 0.01 * circleLength
    const { id1, id2 } = this.state
    const gradientID = streakCurrent ? id1 : id2
    return (
      <svg width={cx * 2} height={cy * 2} xmlns="http://www.w3.org/2000/svg" {...svgProps}>
        <linearGradient id={id2} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#2ed8a7" />
          <stop offset="100%" stopColor="#a6ceff" />
        </linearGradient>
        <linearGradient id={id1} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#ff7f00" />
          <stop offset="100%" stopColor="#ffa900" />
        </linearGradient>
        <circle
          strokeLinecap="round"
          stroke={`url(#${gradientID})`}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circleLength}
          strokeDashoffset={strokeDashoffset}
          strokeMiterlimit="0"
          transform={`rotate(-90, ${cx}, ${cy})`}
          {...circleProps}
        />
      </svg>
    )
  }
}

export default Circle
